import URL from '../helper';
import axiosCall from './interceptor';

export const getAllMailTemplates = async (page, groupByCategory, name, tags, listOfCategoryId, userType, limit, accessType ='') => {
  let payload = {
    page,
    groupByCategory
  };
  if (accessType) payload.accessType = accessType;
  if (name) {
    if (groupByCategory) {
      payload.templateName = name;
    } else {
      payload.searchParam = name;
    }
  }
  if (tags) { payload.tags = tags; }
  if (userType) { payload.userType = userType; }
  if (listOfCategoryId) { payload.listOfCategoryId = listOfCategoryId; }
  if (limit) { payload.limit = limit; }
  else { payload.limit = 8; }

  const searchParam = new URLSearchParams(payload);
  // TODO : include pagination
  const additionalParam = `${userType ? `&userType=${userType}` : ''}${
    accessType ? `&accessType=${accessType}` : ''
  }`;
  const url = groupByCategory
    ? `${URL.BASE_URL}getAllMailTemplate?groupByCategory=true${additionalParam}`
    : `${URL.BASE_URL}getAllMailTemplate?${searchParam.toString()}`;

  let response = await axiosCall('get', url);
  return response.data;
};

export const getSelectedMailTemplates = async ids => {
  const url = `${URL.BASE_URL}getAllMailTemplateByIds?ids=${ids}`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const getMailTemplateDetails = async id => {
  const url = `${URL.BASE_URL}getMailTemplate?id=${id}`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const getAllVariables = async () => {
  const url = `${URL.BASE_URL}getAllVariable`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const saveVariable = async (payload) => {
  const url = `${URL.BASE_URL}saveVariable`;
  const response = await axiosCall('post', url, payload);
  return response.data;
}

export const deleteMailTemplate = async payload => {
  const url = `${URL.BASE_URL}deleteMailTemplate?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const waitForApprovalEmail = async (page, name, tags, categoryIds,accessType) => {

  let payload = {
    page
  };
  if (name) { payload.templateName = name; }
  if (tags) { payload.tags = tags; }
  if (categoryIds) { payload.listOfCategoryId = categoryIds; }
  if (accessType) { payload.accessType = accessType; }
  
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}getAllMailTemplate?templateStatus=Complete&limit=8&${searchParam.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const validateEmailElementName = async (payload) => {
  const url = `${URL.BASE_URL}createElement?applyNameValidation=true`;
  const response = await axiosCall('post', url, payload, false);
  return response.data;
};

export const uploadEmailDataSet = async payload => {
  const url = `${URL.BASE_URL}live/uploadDataSet?channel=email`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};